import { Shield, Award, Users, ThumbsUp } from "lucide-react";

const TrustBadges = ({ className }: { className?: string }) => {
  const badges = [
    {
      icon: Shield,
      title: "Verified Service",
      description: "Registered & insured",
    },
    {
      icon: Award,
      title: "5-Star Rated",
      description: "100+ happy students",
    },
    {
      icon: Users,
      title: "Expert Team",
      description: "Local Melbourne guides",
    },
    {
      icon: ThumbsUp,
      title: "Money Back",
      description: "Satisfaction guaranteed",
    },
  ];

  return (
    <section className={`py-8 md:py-12 bg-muted/30 ${className || ''}`}>
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 max-w-5xl mx-auto">
          {badges.map((badge, index) => (
            <div
              key={index}
              className="flex flex-col items-center text-center p-4 md:p-6 rounded-lg bg-background/50 hover:bg-background transition-all duration-300 hover:shadow-lg animate-fade-in"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              <badge.icon className="h-8 w-8 md:h-10 md:w-10 text-primary mb-2 md:mb-3" />
              <h3 className="text-sm md:text-base font-semibold mb-1">{badge.title}</h3>
              <p className="text-xs md:text-sm text-muted-foreground">{badge.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustBadges;
